"use client";

import { useRef, useState } from "react";
import { CopyIcon } from "@/components/icons/CopyIcon";

export default function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number>(undefined);
  return (
    <button
      type="button"
      className="cp"
      onClick={() => {
        void navigator.clipboard?.writeText(text);
        setCopied(true);
        window.clearTimeout(timer.current);
        timer.current = window.setTimeout(() => setCopied(false), 1400);
      }}
    >
      <CopyIcon />
      {copied ? "Copied" : "Copy"}
    </button>
  );
}
